export default "__VITE_ASSET__CQO1S645__"